export default __webpack_public_path__ + "static/stargate-1a5e1ee56534703e31a4a21fa129cf6e.svg";